import { FileUIPart } from 'ai';
import { RachelFileOutput } from '../../services/modules/rachelFiles/rachelFiles.types';
import { RachelAttachment } from './rachel.files.types';

export const RACHEL_FILE_MAX_SIZE_BYTES = 10 * 1024 * 1024;

export const RACHEL_FILE_ALLOWED_MEDIA_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/webp',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export enum RachelFileValidationError {
  TYPE_NOT_ALLOWED = 'TYPE_NOT_ALLOWED',
  TOO_LARGE = 'TOO_LARGE',
}

export const validateRachelFile = (file: File): RachelFileValidationError | null => {
  if (!RACHEL_FILE_ALLOWED_MEDIA_TYPES.includes(file.type)) {
    return RachelFileValidationError.TYPE_NOT_ALLOWED;
  }
  if (file.size > RACHEL_FILE_MAX_SIZE_BYTES) {
    return RachelFileValidationError.TOO_LARGE;
  }
  return null;
};

export const buildFileUIParts = (attachments: RachelAttachment[]): FileUIPart[] => {
  return attachments
    .filter(
      (attachment): attachment is RachelAttachment & { output: RachelFileOutput } =>
        attachment.status === 'ready' && attachment.output !== undefined,
    )
    .map((attachment) => ({
      type: 'file' as const,
      url: attachment.output.url,
      mediaType: attachment.output.mediaType,
      filename: attachment.output.filename,
    }));
};
